<template>
  <form @submit.prevent="access" class="login__form">
    <!--    <p class="login__form_msg1">{{ $t('login.welcomemsg11') }} <strong>INGECON SUN-->
    <!--      Planner</strong>{{ $t('login.welcomemsg12') }}</p>-->
    <div class="data--center login__form__account">
      <p class="login__form_msg2">{{ $t('login.welcomemsg2') }}</p><i class="pi pi-info-circle"
                                                                      v-tooltip.bottom="'INGECON SUN Monitor, INGECON SUN Planner'"></i>
    </div>
    <!--    user: {{ user }}-->
    <!--    isValid: {{ isValid }}-->
    <!--    <div class="login__form__fields" :class="{'login__form__fields--center': !isValid, 'login__form__fields--end': isValid}">-->
    <div class="login__form__style">
      <div style="height: 300px; margin-bottom: 1rem">
        <div class="login__form__style">
          <div style="height: 250px">
            <div class="login__form__fields" style="height: 150px">
              <input type="email" v-model="user.email" name="username" placeholder="EMAIL" autocomplete="username"/>

              <input type="password" v-model="user.password" name="password" placeholder="PASSWORD"
                     autocomplete="current-password"/>
              <span class="validation__error" v-if="error">{{ $t(error) }}</span>
            </div>
            <div>
              <button type="submit" class="button__general login__wrapper__button border__rounded" @click="access">
                <i v-if="isLoading" class="pi pi-spin pi-spinner" style="font-size: 1.25rem"></i>
                <span>{{ $t('login.loginbutton') }}</span>
              </button>
            </div>
          </div>
          <div>
            <div class="user__actions">
              <button type="button" @click="UpdateloginUserFormStatusData(LoginUserFormStatus.RecoverUserPwd)">
                {{ $t('login.forgotpassword') }}
              </button>
              <button type="button" @click="UpdateloginUserFormStatusData(LoginUserFormStatus.RegisterUser)">
                {{ $t('login.registeruser') }}
              </button>
            </div>
          </div>
        </div>
      </div>
      <img class="loginform__logo" src="../../assets/img/ingeteam_logo.png"/>
    </div>
  </form>

</template>

<script lang="ts">
import {computed, defineComponent, reactive, ref, watch} from "vue";
import {useStore} from "vuex";
import APIDataServices from "@/services/APIDataServices";
import ResponseData from "@/types/ResponseData";
import {LoginUserFormStatus, User, UserEmailPassword, UserEmailPasswordDeviceId, UserId} from "@/types/User";
import {useRouter} from "vue-router";
import BrowsersettingsService from "@/services/TwoFactorAuth/browsersettings.service";
import AuthenticationserviceService from "@/services/authenticationservice.service";

export default defineComponent({
  name: 'LoginUserForm',
  components: {
    // FieldInput
  },
  setup() {
    const store = useStore();
    const router = useRouter();

    const user = reactive({} as UserEmailPassword)

    // const email = ref();
    // const password = ref();
    const isUserValidate = ref(true);
    const isLoading = ref(false);
    const passwordfieldtype = ref("password");

    const UpdateloginUserFormStatusData = (status: LoginUserFormStatus) => {
      store.commit("setLoginUserFormStatus", status);
    }
    const setIsLoading = (status: boolean) => {
      isLoading.value = status;
    }

    const changePasswordFieldType = (e: any) => {
      // console.log('changePasswordFieldType. e: ' + JSON.stringify(e));
      passwordfieldtype.value = passwordfieldtype.value === "password" ? "text" : "password";
      e.preventDefault();
    };

    const userdata = computed(() => {
      const deviceid = BrowsersettingsService.getLocalStorageTwoFactorUUIDVariable();
      const userdata: UserEmailPasswordDeviceId = {email: user.email, password: user.password, deviceid: deviceid};
      return userdata;
    });

    const getTokenAndValidate = () => {
      if (user.email != undefined && user.email != '') {
        setIsLoading(true);

        APIDataServices.getUserTokenISP(userdata.value)
            .then((response: ResponseData) => {
              // console.log('respuesta getUserTokenISM: ' + JSON.stringify(response));
              const tokenISM: string = response.data.tokenISM;
              if (tokenISM) {
                store.commit("setISMToken", tokenISM);
              }
              // if (user) {
              //   AuthenticationserviceService.validateAndSetUser(user, store);
              // }
              // if (token) {
              //   store.commit("setUserToken", token);
              //   router.push({path: `/general/plants`});
              //   AuthenticationserviceService.getGeneralVariables(store);
              // }
            })
            .catch((error: any) => {
              // console.log(`error token. ${JSON.stringify(error.response)}`);
              AuthenticationserviceService.process2FAValidationErrorMsg(error.response.data, store);
              loginFailed();
            });
      } else if (user.email === undefined) {
        user.email = '';
      }
    };

    const ISMToken = computed(() => {
      return store.getters.getISMToken;
    });

    watch(ISMToken, () => {
      if (ISMToken.value && ISMToken.value !== '') {
        APIDataServices.getUserValidateISP(userdata.value, ISMToken.value)
            .then((response: ResponseData) => {
              // console.log('respuesta getUserValidateISP: ' + JSON.stringify(response));
              const token: string = response.data.token;
              const user: User = response.data.user as User;
              if (user) {
                AuthenticationserviceService.validateAndSetUser(user, store);
              }
              if (token) {
                store.commit("setUserToken", token);
                router.push({path: `/general/plants`});
                AuthenticationserviceService.getGeneralVariables(store);
              }
            })
            .catch((error: any) => {
              // console.log(`error getUserValidateISP. ${JSON.stringify(error.response)}`);
              // AuthenticationserviceService.process2FAValidationErrorMsg(error.response.data, store);
              loginFailed();
            });
      }
    });
    const loginFailed = () => {
      isUserValidate.value = false;
      setIsLoading(false);
    }
    const access = (e: any) => {
      getTokenAndValidate();
      e.preventDefault();
    };

    const error = computed(() => {
      return !isUserValidate.value ? 'login.errrormsg' : '';
    });

    // const schema = Yup.object().shape({
    //   username: Yup.string().email().required(),
    //   // password: Yup.string().min(6).required(),
    //   password: Yup.string().required(),
    // }) as any;
    //
    // const {meta, values} = useForm({
    //   validationSchema: schema,
    //   initialValues: user
    // });

    // const isValid = computed(() => meta.value.valid);

    return {
      access,
      UpdateloginUserFormStatusData,
      changePasswordFieldType,
      getTokenAndValidate,
      user,
      error,
      LoginUserFormStatus,
      isLoading,
      // isValid,
      passwordfieldtype
    }
  }
});
</script>

<style scoped>
.login__form {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 95%;
  margin-left: auto;
  margin-right: auto;
}

.login__form__account {
  gap: 1rem;
}

.login__form__account i {
  margin-bottom: 0.5rem;
}

.login__form p {
  /*font-size: 1.5rem;*/
  margin-bottom: 1rem;
  text-align: center;
}

.loginform__logo {
  width: 35%;
}

.login__form_msg1 {
  font-size: calc(1em + 0.4vw);
}

.login__form_msg2 {
  /*font-size: calc(0.8em + 0.3vw);*/
  font-size: 1rem;
}

.login__wrapper__button {
  width: 21.625em;
  height: 3.063em;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 1rem;
  font-weight: bold;
}

.login__form__fields {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  /*width: 600px;*/
}

.password--clear {
  margin-left: -1.875rem;
}

.login__form__fields--end {
  align-items: flex-end;
}

.login__form__fields--center {
  align-items: center;
}

/*.login__form__fields > div {*/
/*  display: grid;*/
/*  grid-template-columns: 2fr 1fr;*/
/*  justify-content: center;*/
/*  align-items: start;*/
/*  justify-items: center;*/
/*}*/

.user__actions {
  display: flex;
  flex-direction: column;
  /*justify-content: space-between;
  width: 21.625em;
  margin-bottom: 0.5rem;*/
}

.user__actions button {
  color: var(--ingeteam-color);
}

/*revert element 'a' styles*/
a {
  all: revert;
}

</style>

<style>
.login__form input {
  border: 1px solid var(--unnamed-color-707070);
  width: 21.625em;
  height: 3.063em;
  margin-bottom: 1rem;
  padding-left: 0.5rem;
}

.login__form__style {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
}
</style>
